import React, { useState, useEffect, useContext } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure autoTable is included
import * as XLSX from "xlsx";
import logo from '../../../../../../../assets/img/logos/logo 2.png';
import { MonthlySumPlant1Api } from "../../../../../../../api/Api";
import {PASS_KEY,WEB_KEY,BaseUrl} from '../../../../../../../api/AxiosApi'
import { AuthenticationContext } from "../../../../../../../context/AuthenticationContext";
import ExportExcel from "../../../../../../../components/exportExcel/ExportExcel1";
import ExportPdf from "../../../../../../../components/exportPdf/ExportPdf";

export default function MonthlySumPlant1Log({SUB_PLANT}) {
    const { LoggedInUserInfo } = useContext(AuthenticationContext)
    const getCurrentMonth = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
    };

    // Function to get date six months ago
    const getSixMonthsAgo = () => {
        const now = new Date();
        now.setMonth(now.getMonth() - 5); // Subtract 6 months
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        return `${year}-${month}`;
    };

    const [startDate, setStartDate] = useState(getSixMonthsAgo()); // 5 months ago
    const [endDate, setEndDate] = useState(getCurrentMonth()); // Current month

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);

    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("KEY") || "",
        LCODE: sessionStorage.getItem("LCODE") || "",
        MT1: startDate,
        MT2: endDate,
        TYP: "A",
        WEB_KEY: "WEBXYZ321",
        FID: "216HT001",
        SUB_PLANT:SUB_PLANT
    };

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        try {
            const res = await MonthlySumPlant1Api(credentials);
            if (res?.MONTH_SUM && Array.isArray(res?.MONTH_SUM)) {
                setLogData(res?.MONTH_SUM);
                setTotalPages(Math.ceil(res?.MONTH_SUM.length / rowsPerPage));
            } else {
                // console.error("Invalid data structure:", res);
                setLogData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [startDate, endDate]);

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

    // Pagination: Slice data based on the current page
    const paginatedData = logData.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    // Pagination controls
    const goToPage = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    // // Export to Excel
    // const exportToExcel = () => {
    //     const table = document.getElementById("log-table");
    //     const rows = Array.from(table.rows);

    //     let tableData = [];
    //     rows.forEach((row) => {
    //         const cells = Array.from(row.cells).map(cell => cell.innerText);
    //         tableData.push(cells);
    //     });

    //     const ws = XLSX.utils.aoa_to_sheet(tableData);
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Monthly Report");
    //     XLSX.writeFile(wb, `Monthly Energy Summary To ${new Date().toLocaleDateString()}Monthly Energy Summaries.xls`);
    // };

    // // Export to PDF
    // const exportToPDF = () => {
    //     const doc = new jsPDF();
    //     const table = document.getElementById("log-table");

    //     if (!table) {
    //         alert("Table not found!");
    //         return;
    //     }

    //     const rows = Array.from(table.rows);

    //     // Extract header and body data from the table
    //     const tableData = [];
    //     const headers = Array.from(rows[0].cells).map(cell => cell.innerText.trim());
    //     tableData.push(headers);

    //     for (let i = 1; i < rows.length; i++) {
    //         const rowData = Array.from(rows[i].cells).map(cell => cell.innerText.trim());
    //         tableData.push(rowData);
    //     }

    //     // === Add Logo (Centered at the Top) ===
    //     const imgWidth = 20;  // Logo width
    //     const imgHeight = 18; // Logo height
    //     const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
    //     doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at the top

    //     // === Add Title Below Logo ===
    //     const title = `Monthly Energy Summary - ${new Date().toLocaleDateString()}`;  // Dynamic title
    //     doc.setFontSize(12);
    //     doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Centered below logo

    //     // === Generate Table Below the Title ===
    //     let startY = 50;  // Position table below the title

    //     doc.autoTable({
    //         head: [headers],
    //         body: tableData.slice(1),  // Exclude the header from the body
    //         startY: startY,
    //         margin: { horizontal: 10 },
    //         theme: 'grid',
    //         styles: {
    //             cellPadding: 5,
    //             fontSize: 10,
    //             halign: 'center'  // Center-align table cells
    //         }
    //     });

    //     // === Save the PDF with a Dynamic Name ===
    //     doc.save(`Monthly Energy Summary To ${new Date().toLocaleDateString()}Monthly Energy Summaries`);
    // };

    const exportToExcel = async () => {
        await ExportExcel(
            ImageUrl,
            logData,
            startDate,
            endDate,
            "Monthly Energy Summary",
            LoggedInUserInfo
        );
    };
    
    const exportToPDF = async () => {
        await ExportPdf(
            ImageUrl,
            paginatedData,
            startDate,
            endDate,
            "Monthly Energy Summary",
            LoggedInUserInfo,
            logo,
            tableHeaders

        );
    };



    return (
        <div style={{ padding: "10px", fontFamily: "Arial, sans-serif" }}>
            {/* Top Section */}
            <div style={containerStyle}>
                <p style={responsiveHeaderStyle}>Monthly Energy Summary Log</p>
                <div style={responsiveControlsStyle}>
                    <label>
                        {/* From Date: */}
                        <input
                            type="month"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <label>
                        {/* To Date: */}
                        To
                        <input
                            type="month"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={inputStyle}
                        />
                    </label>
                    <button onClick={fetchLogData} style={buttonStyle}>
                        Show
                    </button>
                    <button onClick={exportToExcel} style={exportButtonStyle}>
                        Excel
                    </button>
                    <button onClick={exportToPDF} style={exportButtonStyle2}>
                        PDF
                    </button>
                </div>
            </div>

            {/* Table Section */}
            <div className="table-responsive">
                <table id="log-table" className="table table-hover table-bordered">
                    <thead style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                        <tr>
                            {tableHeaders.map((header, index) => (
                                <th
                                    key={index}
                                    className="text-center align-middle"
                                    style={{
                                        color: "rgb(53, 110, 53)",
                                        padding: "12px 10px",
                                        whiteSpace: "nowrap",
                                        minWidth: "100px",
                                        fontSize: "14px",
                                    }}
                                >
                                    {header.replace(/_/g, " ")}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td
                                    colSpan={tableHeaders.length}
                                    className="text-center"
                                    style={{ padding: "15px" }}
                                >
                                    Loading...
                                </td>
                            </tr>
                        ) : paginatedData.length > 0 ? (
                            paginatedData.map((item, rowIndex) => (
                                <tr key={rowIndex}>
                                    {tableHeaders.map((key, colIndex) => (
                                        <td
                                            key={colIndex}
                                            className="text-center align-middle"
                                            style={{
                                                padding: "10px",
                                                whiteSpace: "nowrap",
                                                minWidth: "100px",
                                            }}
                                        >
                                            {item[key] !== null && item[key] !== undefined ? item[key] : ""}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td
                                    colSpan={tableHeaders.length}
                                    className="text-center"
                                    style={{ padding: "15px" }}
                                >
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>


            {/* Pagination Controls */}
            <div style={{ textAlign: "right", marginTop: "20px" }}>
                <button onClick={() => goToPage(currentPage - 1)} style={paginationButtonStyle}>
                    Prev
                </button>
                <span style={{ margin: "0 10px" }}>
                    Page {currentPage} of {totalPages}
                </span>
                <button onClick={() => goToPage(currentPage + 1)} style={paginationButtonStyle}>
                    Next
                </button>
            </div>

            {/* Error Message */}
            {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
        </div>
    );
}

/* Styles */
const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    border: "1px solid lightgray",
    padding: "2px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "3px 6px",
    borderRadius: "14px",
    border: "1px solid #ccc",
    marginLeft: "5px",
    fontSize: "10px",
};

const buttonStyle = {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "2px 9px",
    cursor: "pointer",
    fontSize: "10px",
};

const exportButtonStyle = {
    backgroundColor: "darkblue",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const exportButtonStyle2 = {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};



const paginationButtonStyle = {
    backgroundColor: "#fff",
    color: "#356E35",
    border: "1px solid #ddd",
    borderRadius: "7px",
    padding: "6px 12px",
    cursor: "pointer",
    fontSize: "14px",
    margin: "0 5px",
};
